import React, { useState } from "react";
import Chat from "./Chat";
import ChatList from "./ChatList";
import { Box } from "@mui/material";
import Styles from "../../assets/styles/Chat.module.scss";
const ChatContainer = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div className={Styles.chatContainer}>
      <Box className={Styles.leftContainer}>
        <ChatList refreshKey={refreshKey} />
      </Box>
      <Box className={Styles.rightContainer}>
        <Chat setRefreshKey={setRefreshKey} refreshKey={refreshKey} />
      </Box>
    </div>
  );
};

export default ChatContainer;
